import {
  ADD_NEW_TEMPLATE,
  SET_TEMPLATES,
  APPEND_TEMPLATES,
  APPEND_STANDARD_TEMPLATES,
  UPDATE_DESIGN_TEMPLATE,
  SET_DESIGN_TEMPLATE,
  ADD_LAYER,
  UPDATE_LAYER,
  UPDATE_LAYER_COLOR,
  UPDATE_LAYERS,
  UPDATE_ZOOM,
  SET_INITIAL_TEMPLATE_SIZING,
  SET_SELECTED_LAYER_ID,
  UPDATE_TEMPLATE,
  DELETE_TEMPLATE,
  UPDATE_TEMPLATE_SETTINGS,
  SET_SHARED_TEMPLATES,
  CLEAR_SHARED_TEMPLATES,
  ADJUST_FAVORITE_COUNT,
  CLEAR_TEMPLATES_DATA,
  UPDATE_FONT_SIZE,
  REMOVE_SHARED_TEMPLATE,
  SET_IS_LOADING_USER_TEMPLATES,
  SET_STANDARD_TEMPLATES,
  SET_LOADING_STANDARD_TEMPLATES,
  SET_TEMPLATE_CATEGORIES,
  SET_TEMPLATE_PACKS,
} from "../types";

const initialState = {
  userTemplates: [],
  isLoadingUserTemplates: false,
  isLoadingStandardTemplates: true, // This is true as we are alwasy loading the standard templates
  templateCategories: [],
  templatePacks: [],
  sharedTemplates: [],
  standardTemplates: [],
  favoriteTemplates: [],
  designTemplate: { layers: [] }, // This is the template that the user is currently working on
  zoom: 100,
  isInitialTemplateSizing: false,
  selectedLayerId: null,
  guidelinesOn: true,
  boundingBoxOn: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_TEMPLATES:
      return {
        ...state,
        userTemplates: [...action.payload],
      };
    case SET_IS_LOADING_USER_TEMPLATES:
      return {
        ...state,
        isLoadingUserTemplates: action.payload,
      };
    case APPEND_TEMPLATES:
      let userTemplates = [...state.userTemplates, ...action.payload];

      // Dedupe user templates
      let dedupedUserTemplates = [];
      let userTemplateIds = [];
      userTemplates.forEach((template) => {
        if (!userTemplateIds.includes(template.templateId)) {
          dedupedUserTemplates.push(template);
          userTemplateIds.push(template.templateId);
        }
      });

      return {
        ...state,
        userTemplates: dedupedUserTemplates,
      };
    case APPEND_STANDARD_TEMPLATES:
      let standardTemplates = [...state.standardTemplates, ...action.payload];

      // Dedupe standard templates
      let dedupedStandardTemplates = [];
      let templateIds = [];
      standardTemplates.forEach((template) => {
        if (!templateIds.includes(template.templateId)) {
          dedupedStandardTemplates.push(template);
          templateIds.push(template.templateId);
        }
      });

      return {
        ...state,
        standardTemplates: dedupedStandardTemplates,
      };
    case SET_SHARED_TEMPLATES:
      return {
        ...state,
        sharedTemplates: [...state.sharedTemplates, ...action.payload],
      };
    case CLEAR_SHARED_TEMPLATES:
      return {
        ...state,
        sharedTemplates: [],
      };
    case ADD_NEW_TEMPLATE:
      return {
        ...state,
        userTemplates: [action.payload, ...state.userTemplates],
      };
    case UPDATE_DESIGN_TEMPLATE:
      return {
        ...state,
        designTemplate: {
          ...state.designTemplate,
          ...action.payload,
        },
      };
    case SET_DESIGN_TEMPLATE:
      return {
        ...state,
        designTemplate: action.payload,
      };
    case ADD_LAYER: {
      return {
        ...state,
        designTemplate: {
          ...state.designTemplate,
          layers: [...state.designTemplate.layers, action.payload],
        },
      };
    }
    case UPDATE_LAYER: {
      const newLayers = state.designTemplate.layers.map((layer) => {
        if (layer.id === action.payload.layerId) {
          return {
            ...layer,
            ...action.payload.updateValues,
          };
        } else {
          return layer;
        }
      });

      return {
        ...state,
        designTemplate: {
          ...state.designTemplate,
          layers: newLayers,
        },
      };
    }
    case UPDATE_FONT_SIZE: {
      const newLayers = state.designTemplate.layers.map((layer) => {
        if (layer.id === action.payload.layerId) {
          return {
            ...layer,
            fontSize: action.payload.fontSize,
          };
        } else {
          return layer;
        }
      });

      return {
        ...state,
        designTemplate: {
          ...state.designTemplate,
          layers: newLayers,
        },
      };
    }

    case UPDATE_LAYER_COLOR: {
      const newLayers = state.designTemplate.layers.map((layer) => {
        if (layer.id === action.payload.layerId) {
          return {
            ...layer,
            ...action.payload.updateValues,
          };
        } else {
          return layer;
        }
      });

      return {
        ...state,
        designTemplate: {
          ...state.designTemplate,
          layers: newLayers,
        },
      };
    }
    case UPDATE_LAYERS: {
      return {
        ...state,
        designTemplate: {
          ...state.designTemplate,
          layers: action.payload,
        },
      };
    }
    case UPDATE_ZOOM: {
      return {
        ...state,
        zoom: action.payload,
      };
    }
    case SET_INITIAL_TEMPLATE_SIZING: {
      return {
        ...state,
        isInitialTemplateSizing: action.payload,
      };
    }
    case SET_SELECTED_LAYER_ID: {
      return {
        ...state,
        selectedLayerId: action.payload,
      };
    }
    case UPDATE_TEMPLATE: {
      const newTemplates = state.userTemplates.map((template) => {
        if (template.templateId === action.payload.templateId) {
          return {
            ...template,
            ...action.payload.updateValues,
          };
        } else {
          return template;
        }
      });

      return {
        ...state,
        userTemplates: [...newTemplates],
      };
    }
    case DELETE_TEMPLATE: {
      const newTemplates = state.userTemplates.filter(
        (template) => template.templateId !== action.payload
      );

      return {
        ...state,
        userTemplates: [...newTemplates],
      };
    }
    case UPDATE_TEMPLATE_SETTINGS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case ADJUST_FAVORITE_COUNT: {
      let { templateId, adjustment } = action.payload;

      const newSharedTemplates = state.sharedTemplates.map((sharedTemplate) => {
        if (sharedTemplate.templateId === templateId) {
          return {
            ...sharedTemplate,
            favoriteCount: sharedTemplate.favoriteCount + adjustment,
          };
        } else {
          return sharedTemplate;
        }
      });

      return {
        ...state,
        sharedTemplates: [...newSharedTemplates],
      };
    }
    case CLEAR_TEMPLATES_DATA: {
      return {
        ...initialState,
        zoom: state.zoom,
        isLoadingStandardTemplates: state.isLoadingStandardTemplates, // Preserve loading state
        standardTemplates: state.standardTemplates, // Preserve standard templates
        templateCategories: state.templateCategories, // Preserve template categories
        templatePacks: state.templatePacks, // Preserve template packs
      };
    }
    case REMOVE_SHARED_TEMPLATE: {
      return {
        ...state,
        sharedTemplates: state.sharedTemplates.filter(
          (template) => template.templateId !== action.payload
        ),
      };
    }
    case SET_STANDARD_TEMPLATES: {
      return {
        ...state,
        standardTemplates: action.payload,
      };
    }
    case SET_LOADING_STANDARD_TEMPLATES: {
      return {
        ...state,
        isLoadingStandardTemplates: action.payload,
      };
    }
    case SET_TEMPLATE_CATEGORIES: {
      return {
        ...state,
        templateCategories: action.payload,
      };
    }
    case SET_TEMPLATE_PACKS: {
      return {
        ...state,
        templatePacks: action.payload,
      };
    }

    default:
      return state;
  }
}
